export const setUserSessionAuthKey = () => {
  let localData = localStorage.getItem("rebelSkoolUser");
  let localObject = localData && JSON.parse(localData);
  if (null != localObject) {
    let userSessionAuthKey = localObject.userSessionAuthKey;
    if (userSessionAuthKey != "" && userSessionAuthKey != null) {
      let axiosConfig = {
        headers: {
          "User-Session-Auth-Key": localObject.userSessionAuthKey,
        },
      };
      return axiosConfig;
    } else return false;
  } else return false;
};

export const numberWithCommasAndSpace = (amount) => {
  let amountString = amount.toString();
  if (!amountString.includes(".")) {
    amount = amount.toFixed(2);
  }

  return amount
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
    .replace(".", ",");
};
